import { useFormat } from '../composables/useFormat.js';
import { useDotnet } from '../composables/useDotnet.js';
import { useAuthStore } from '../stores/auth.js';

/**
 * Global utilities plugin for Vue 3
 * Provides format and dotnet utilities as global properties
 */
export default {
  install(app) {
    // Add global properties that were previously mixins
    app.config.globalProperties.$format = useFormat();
    app.config.globalProperties.$dotnet = useDotnet();
    
    // Add auth store helper
    app.config.globalProperties.$auth = () => useAuthStore();
    
    // Provide access to common utilities
    app.provide('format', useFormat());
    app.provide('dotnet', useDotnet());
  }
};
